import styled from "styled-components";

export const NoMatchPageWrapper = styled.div`
`;